// 主にサイドバー制御に使っている
// レスポンシブにするだけでなく、自由にサイドバー開閉制御がしたかったため bootstrap を外してこんなことをしている。
// bootstrapや他で置き換えできればそれに移行したい。

document.addEventListener("DOMContentLoaded", () => {
  let isDashboard = false;
  if (window.location.pathname === "/dashboard/index") isDashboard = true;

  // elements
  const sidebar = document.getElementById("sidebar");
  const content = document.getElementById("content");
  const sidebarBtn = document.getElementById("sidebarBtn");

  // constants
  const sidebarZIndex = 100; // sidebarの上に他の要素が表示されないように
  const widthThrethold = 1000;
  const paddingLeftOffset = isDashboard ? 10 : 40; // isDashboard では sidebar を常に閉じたままにする
  const sidebarWidth = sidebar.clientWidth;

  // style
  sidebar.style.zIndex = sidebarZIndex;
  sidebar.style.transition = "all 0.2s";

  function setupContentPaddingLeft(pl) {
    // contents 部分はサイドバー分の　padding　をっておく
    content.style.setProperty("padding-left", pl + paddingLeftOffset + "px", "important");
  }

  function close() {
    sidebar.style.transform = "translateX(" + -sidebarWidth + "px)";
    sidebarBtn.innerText = ">>";
    setupContentPaddingLeft(0);
    // 最後に
    sidebar.classList.remove("isOpen");
  }

  function open() {
    sidebar.style.transform = "translateX(" + 0 + "px)";
    sidebarBtn.innerText = "<<";
    if (!isDashboard) setupContentPaddingLeft(sidebarWidth);
    //　最後に
    sidebar.classList.add("isOpen");
  }

  function onclick() {
    const isOpen = sidebar.classList.contains("isOpen");
    if (isOpen) {
      close();
    } else {
      open();
    }
  }

  const onResize = () => {
    const isOpen = sidebar.classList.contains("isOpen");
    const width = window.innerWidth;
    if (width >= widthThrethold) {
      if (!isOpen) {
        open();
      }
    } else {
      if (isOpen) {
        close();
      }
    }
  };

  function init() {
    setupContentPaddingLeft(sidebarWidth);

    // 初期のwindowサイズが小さければ閉じておく
    const width = window.innerWidth;
    if (width < widthThrethold) {
      close();
    }
  }

  init();

  if (isDashboard) {
    setupContentPaddingLeft(10);
    close();
  } else {
    window.addEventListener("resize", onResize);
  }
  sidebarBtn.onclick = onclick;
});
